import React from 'react'
import ReactDOM from 'react-dom'

import 'styles/main.less'

import Root from './components/App'

ReactDOM.render(
	<Root />,
	document.getElementById('root')
)
